import { render, staticRenderFns } from "./InvoiceReceives.vue?vue&type=template&id=47e59bbb&"
import script from "./InvoiceReceives.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports